import { render, staticRenderFns } from "./EditRecordDialog.vue?vue&type=template&id=0c51bfb8&scoped=true&"
import script from "./EditRecordDialog.vue?vue&type=script&lang=js&"
export * from "./EditRecordDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditRecordDialog.vue?vue&type=style&index=0&id=0c51bfb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c51bfb8",
  null
  
)

export default component.exports